import types from './types';
import { getUser, login as _login, logout as _logout } from '@/core/auth';
import { getUserMenu, getAdditionalProfileInfo } from '../api';
import { USER_MENU_APP_SESSION_KEY } from '@/config';

export default {
  async init({ state, commit }) {
    try {
      const user = await getUser();
      commit(types.SET_USER, user);

      if (
        state.user &&
        (!state.userMenu || !state.companies || !state.permissions)
      ) {
        const [userMenu, additionalProfileInfo] = await Promise.all([
          await getUserMenu(),
          await getAdditionalProfileInfo(),
        ]);

        if (userMenu && userMenu.length) {
          commit(types.SET_MENU, userMenu);
          sessionStorage.setItem(
            USER_MENU_APP_SESSION_KEY,
            JSON.stringify(userMenu)
          );
        }

        if (additionalProfileInfo) {
          const { companies, permissions } = additionalProfileInfo;

          commit(types.SET_COMPANIES, companies);
          sessionStorage.setItem('user-companies', JSON.stringify(companies));

          commit(types.SET_PERMISSIONS, permissions);
          sessionStorage.setItem(
            'user-permissions',
            JSON.stringify(permissions)
          );
        }
      }
    } catch {
      commit(types.SET_USER, null);
      commit(types.SET_MENU, null);
      commit(types.SET_PERMISSIONS, null);
      commit(types.SET_COMPANIES, null);
      sessionStorage.removeItem(USER_MENU_APP_SESSION_KEY);
      sessionStorage.removeItem('user-permissions');
      sessionStorage.removeItem('user-companies');
    }
  },

  async clearSession() {
    sessionStorage.removeItem(USER_MENU_APP_SESSION_KEY);
    sessionStorage.removeItem('user-permissions');
    sessionStorage.removeItem('user-companies');

    sessionStorage.clear();
  },

  login() {
    _login();
  },

  logout({ state, dispatch }) {
    let logoutId = state.user.profile.sub;
    _logout();
    dispatch('clearSession').then(function() {
      /* Señor FORCE */
      let urlLogout = process.env.VUE_APP_URL_AUTH;
      urlLogout += process.env.VUE_APP_ACR_URL_LOGOUT;
      urlLogout += '/?logoutid=' + logoutId;
      urlLogout +=
        '&redirectUrl=' + process.env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI;
      window.location.replace(urlLogout);
      // Validar como hacer logout sin enviar tantos parametros y de la forma adecuada -_- :/
    });
  },

  setMenuItemId(context, menuItemId) {
    context.commit(types.SET_MENU_ITEM_ID, menuItemId);
  },
};
